import React from 'react';
import classes from './style.module.css';

const InputText = ({
    name,
    register,
    placeholder,
    label
}) => {
    return (
        <label
            htmlFor={name}
            className={classes.label}
        >
            <span className={classes.label__helper}>
                {label}
            </span>
            <input
                {...register(name)}
                type="text"
                id={name}
                placeholder={placeholder}
                className={classes.label__field}
            />
        </label>
    )
}

export default InputText;